// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  line-height: 1.5;
}

.h6,
h6 {
  font-size: 0.875rem;
}

.birth-date {
  font-family: Poppins, sans-serif !important;
  font-size: 46px;
  margin-top: -15px;
  font-weight: 100 !important;
}

.card {
  margin-bottom: 1rem;
  background-color: var(--foreground-secondary) !important;
  border-radius: 7px !important;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
}

.birthday-page .card {
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5) !important;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.birthDay-contain,
.dashboard-page .card,
.floating-labels select.form-control > option {
  background: var(--foreground-secondary);
  border-radius: 7px !important;
}

.birthDay-contain .btn-birthDaysubmit {
  margin: 15px 0;
}

.birthDay-contain .card-body {
  padding: 0.2rem 1.25rem;
}

.birthDay-contain h5.c2lbiz-ae-steps-body-title {
  margin-top: 6px;
}

.birthDay-contain h5 {
  margin-bottom: 0;
}

.p-2 {
  padding: 0.5rem !important;
}

.row {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-wrap: wrap;
}

.card .card-title {
  position: relative;
  font-weight: 500;
  color: coral;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iconClass {
  color: grey;
}

.messages_noData {
  padding-bottom: 30px;
  line-height: 0.5 !important;
}

.nodataclass {
  width: 40%;
  height: 425px;
  margin: 20px;
}

@media only screen and (max-width: 900px) {
  .nodataclass {
    width: 80%;
    height: 425px;
    margin: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/insurerDashboard/contestWise/contestWise.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;;EAEE,mBAAA;AACF;;AAEA;EACE,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,mBAAA;EACA,wDAAA;EACA,6BAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,qDAAA;EACA,oCAAA;AACF;;AAEA;;;EAGE,uCAAA;EACA,6BAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;AAEF;;AACA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,oBAAA;EACA,2BAAA;AAEF;;AACA;EACE,UAAA;EACA,aAAA;EACA,YAAA;AAEF;;AACA;EACE;IACE,UAAA;IACA,aAAA;IACA,YAAA;EAEF;AACF","sourcesContent":["* {\n  line-height: 1.5;\n}\n\n.h6,\nh6 {\n  font-size: 0.875rem;\n}\n\n.birth-date {\n  font-family: Poppins, sans-serif !important;\n  font-size: 46px;\n  margin-top: -15px;\n  font-weight: 100 !important;\n}\n\n.card {\n  margin-bottom: 1rem;\n  background-color: var(--foreground-secondary) !important;\n  border-radius: 7px !important;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 1.25rem;\n}\n\n.birthday-page .card {\n  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5) !important;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.birthDay-contain,\n.dashboard-page .card,\n.floating-labels select.form-control > option {\n  background: var(--foreground-secondary);\n  border-radius: 7px !important;\n}\n\n.birthDay-contain .btn-birthDaysubmit {\n  margin: 15px 0;\n}\n\n.birthDay-contain .card-body {\n  padding: 0.2rem 1.25rem;\n}\n\n.birthDay-contain h5.c2lbiz-ae-steps-body-title {\n  margin-top: 6px;\n}\n.birthDay-contain h5 {\n  margin-bottom: 0;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.row {\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.card .card-title {\n  position: relative;\n  font-weight: 500;\n  color: coral;\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.iconClass {\n  color: grey;\n}\n\n.messages_noData {\n  padding-bottom: 30px;\n  line-height: 0.5 !important;\n}\n\n.nodataclass {\n  width: 40%;\n  height: 425px;\n  margin: 20px;\n}\n\n@media only screen and (max-width: 900px) {\n  .nodataclass {\n    width: 80%;\n    height: 425px;\n    margin: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
